import { httpCall } from "@common/util";
import AppConstants from "@config/appConstants";
import { getEndpointUrl } from "./config/getEndpointUrl";

export const fetchNavigation = () => {
  return httpCall({
    method: AppConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: getEndpointUrl("navigation"),
  });
};
